<template>
  <app-header-modal
    :prop-land-code="landCode"
    :tilda-redirect="redirectOnSuccess"
    class="tilda-header-modal"
  />
</template>

<script>
import { mapActions } from 'vuex';
import AppHeaderModal from '~/components/v2/common/AppHeader/AppHeaderModal.vue';
import { MODAL_TYPES } from '~/components/v2/common/AppHeader/data';
import { removeSalebot } from '~/utils/removeSalebot';

export default {
  name: 'TildaItogovoeSochinenie',
  components: { AppHeaderModal },
  layout: 'emptyLayout',

  head: {
    meta: [{ name: 'robots', content: 'noindex' }],
  },

  computed: {
    landCode() {
      const defaultLandcode = 'schus_tilda_itog_soch_24_lid_form';
      if (process.browser) {
        return this.$route?.query?.landcode || defaultLandcode;
      }
      return defaultLandcode;
    },
    redirectOnSuccess() {
      const defaultLink = 'https://salebot.site/418644cd290a7f865895656f2819427a_1';
      if (process.browser) {
        return this.$route?.query?.onsuccess || defaultLink;
      }
      return defaultLink;
    },
  },

  created() {
    this.openModal(MODAL_TYPES.courseSignUp);
  },
  mounted() {
    removeSalebot();
  },

  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style scoped lang="scss">

.tilda-header-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  ::v-deep(.header-modal__inner) {
    width: 720px;
    padding: 32px 40px 40px;
    border-radius: 60px;

    @include media-down($size-tablet) {
      width: min(366px, calc(100vw - 40px));
      padding: 20px 8px 8px;
      border-radius: 32px;
    }

    .header-modal__title {
      h6 {
        font-size: 48px;

        @include media-down($size-tablet) {
          font-size: 40px;
          padding-inline: 8px;
        }
      }

      p.header-modal__title_cheap {
        padding: 12px 20px;
        border-radius: 40px;
        font-size: 26px;

        right: 30px;
        top: 4px;
        bottom: auto;
        left: auto;

        @include media-down($size-tablet) {
          padding: 4px 10px 6px;
          font-size: 14px;

          top: auto;
          bottom: 2px;
          right: auto;
          left: 152px;
        }
      }
    }

    .header-modal__fields {
      gap: 8px;
      margin-block: 20px;

      @include media-down($size-tablet) {
        padding-inline: 8px;
      }

      .form__input {
        input:not(.phone-field__input) {
          height: 80px;
          font-size: 26px;

          @include media-down($size-tablet) {
            height: 68px;
            font-size: 18px;
          }
        }

        .phone-field__input {
          font-size: 26px;

          @include media-down($size-tablet) {
            font-size: 18px;
          }
        }
      }
    }

    .header-modal__law {
      margin-bottom: 40px;
      font-size: 20px;

      @include media-down($size-tablet) {
        font-size: 14px;
      }
    }

    .header-modal__btn {
      padding: 36px 10px;
      border-radius: 24px;
      font-size: 32px;

      @include media-down($size-tablet) {
        padding: 30px 0;
        font-size: 18px;
      }
    }
  }
}

::v-deep(.header-modal__overlay),
::v-deep(.header-modal__close) {
  display: none;
}

::v-deep(.header-modal__inner) {
  &::-webkit-scrollbar {
    width: 2px;
    background-color: #ECEDF0;
  }
}

@include media-down($size-mobile) {
  ::v-deep(.header-modal__inner) {
    max-width: calc(100vw - 35px);
  }
}

</style>
